import { NetworkStatus } from '../../device-api/network-status';
export class BrowserNetworkStatus extends NetworkStatus {
    context;
    constructor(context) {
        super();
        this.context = context;
        this.context.addEventListener('online', this.handleConnected.bind(this));
        this.context.addEventListener('offline', this.handleDisconnected.bind(this));
    }
    getNetworkConnectionStatus() {
        return this.context.navigator.onLine ? 1 /* ConnectionStatus.Connected */ : 0 /* ConnectionStatus.Disconnected */;
    }
    getNetworkConnectionType() {
        const navigator = this.context.navigator;
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (connection) {
            const type = connection.type;
            if (type) {
                if (type === "cellular" /* BrowserConnectionType.Cellular */) {
                    return connection.effectiveType.toUpperCase();
                }
                return type.toLowerCase();
            }
        }
        return "unknown" /* ConnectionType.Unknown */;
    }
    handleConnected() {
        this.notifyConnectionStatusChanged(1 /* ConnectionStatus.Connected */);
    }
    handleDisconnected() {
        this.notifyConnectionStatusChanged(0 /* ConnectionStatus.Disconnected */);
    }
}
//# sourceMappingURL=browser-network-status.js.map